import { render, staticRenderFns } from "./StockKittingToolNotAllowedIcon.vue?vue&type=template&id=3bc44086&"
import script from "./StockKittingToolNotAllowedIcon.vue?vue&type=script&lang=js&"
export * from "./StockKittingToolNotAllowedIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QIcon,QTooltip} from 'quasar'
component.options.components = Object.assign({QIcon,QTooltip}, component.options.components || {})
